// extracted by mini-css-extract-plugin
module.exports = {"rotation":"TecnologieHubTemplate_rotation__BN15a"};